// extracted by mini-css-extract-plugin
module.exports = {"root":"SirfWebCheckinReminder-module__root___S-FS-"};